import React from 'react'
import Icon from './Icon'

class SmallCross extends React.Component {
  render () {
    return (
      <Icon {...this.props}>
        <svg width='10px' height='10px' viewBox='0 0 10 10'>
          <g
            id='icons'
            stroke='none'
            strokeWidth='1'
            fill='none'
            fillRule='evenodd'
            opacity='0.185984142'
          >
            <g
              transform='translate(-485.000000, -539.000000)'
              id='smallcross'
              className='icon__fill'
              fill='#000000'
            >
              <polygon points='495 540.41 493.59 539 490 542.59 486.41 539 485 540.41 488.59 544 485 547.59 486.41 549 490 545.41 493.59 549 495 547.59 491.41 544' />
            </g>
          </g>
        </svg>
      </Icon>
    )
  }
}

export default SmallCross
